const MAX_TRIES = 20;

export default (element, controllerName) => {
  const getController = (el) => {
    if (window.primaryApplication) {
      return window.primaryApplication.getControllerForElementAndIdentifier(el, controllerName);
    }

    return null;
  };

  let tries = 0;

  return new Promise((resolve) => {
    const controller = getController(element);

    if (controller) {
      resolve(controller);
      return;
    }

    // If the cart summary is not initialized yet, try again in a moment
    const interval = setInterval(() => {
      tries += 1;

      if (tries > MAX_TRIES) {
        return;
      }

      const controllerInInterval = getController(element);

      if (controllerInInterval) {
        resolve(controllerInInterval);
        clearInterval(interval);
      }
    }, 100);
  });
};
